import React, { useEffect, useState, useMemo } from 'react';
import { Bubble } from 'tea-component';
// import defaultKol from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import loadingSvg from '@/pages/intelligence/assets/svg/loading.svg';
import classsName from 'classnames';
import { addImageMogr2Url, isObject } from '@/pages/intelligence/utils/commonUtils';
import GameImage from '@/pages/home/components/GameImage';

import './index.scss';
const TableImg = (porps: any) => {
  const { cvm, getClick, searchValue, isNeedMogr = false, entityType, tableIconMap } = porps;

  return (
    <div className="dbi-cycle-img-flex">
      {Array.isArray(cvm) && cvm?.length > 0 ? (
        cvm.map((item: any, i: any) => (
          <ImageRender
            key={i}
            item={tableIconMap[item]}
            searchValue={searchValue}
            getClick={getClick}
            entityType={entityType}
          />
        ))
      ) : (
        <div style={{ color: '#838697' }}>-</div>
      )}
    </div>
  );
};

export default TableImg;

const ImageRender = (props: any) => {
  const { item, searchValue, getClick, entityType } = props;
  const contentStr = item?.entity_name || item?.name || '';
  const [imageSrc, setImageSrc] = useState(loadingSvg);
  const [loading, setLoading] = useState(true);
  const CssImageTypeList = ['pc', 'console'];

  useEffect(() => {
    if (item) {
      const { cover } = item;
      const newImg = new Image();
      newImg.src = cover;
      newImg.onerror = () => {
        setImageSrc('');
        setLoading(false);
      };
      newImg.onload = () => {
        setImageSrc(newImg.src);
        setLoading(false);
      };
    }
  }, [item]);

  return (
    <Bubble dark content={contentStr}>
      {loading ? (
        <div className={`dbi-img-loading-container${entityType == 'pc' ? `-${entityType}` : ''}`}>
          <img src={imageSrc} className="img-loading" />
        </div>
      ) : (
        <GameImage
          className={classsName(
            `dbi-cycle-${CssImageTypeList.includes(entityType) ? entityType : 'img'}`,
            {
              // img-action 当只有搜索图片项与当前吻合时。才会出现高亮，不在遍历一遍数据增加actions
              'img-action': searchValue && [item.imgSrc].includes(searchValue),
              'img-loading': loading,
            },
          )}
          onClick={() => {
            getClick?.(item);
          }}
          src={imageSrc}
          entityType={entityType}
          bubbleContent={contentStr}
          alt=""
        />
      )}
    </Bubble>
  );
};
